module.exports = __webpack_public_path__ + "static/media/bg-table-contents.7cd2dbe5.png";